import React from 'react';
import { useLocation } from 'react-router-dom';

export const useQuery = () => {
  const location = useLocation();

  return React.useMemo(() => new URLSearchParams(location.search), [location]);
};
